import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import React, { useMemo, useState } from 'react';
import generatePath from '@utils/generatePath';
import { TUTOR_PAGE} from 'constants/url';
import { history } from '@store/history';
import { qsParse } from '@utils/url-utils';
import styles from './styles.scss';

type IProps = {
	regId?: string;
	title?: string;
	name?: string;
	mark?: string;
}

export default function (props: IProps){
	const [item, setItem] = useState<any>();
	const { regId, title, name, mark} = qsParse();
	const { width } = useResizeObserver();
	const listAll = [
		{
			title: "Primary school",
			value: "UK_Y1",
			img: "https://web-data.zmlearn.com/image/j6eZ8wJR3LBGg5XREhDnpQ/primaryschool.png"
		},
		{
			title: "Secondary school - GCSE & under",
			value: "UK_Y7",
			img: "https://web-data.zmlearn.com/image/6RC1kzqZuJcBP9uaqsVvmN/secondaryschool.png"
		},
		{
			title: "A-level",
			value: "UK_Y10",
			img: "https://web-data.zmlearn.com/image/dPnirF18sAGXkaU7ktSZzB/alevelschool.png"
	}];
	if (item) {
		history.push({
			pathname: generatePath(TUTOR_PAGE),
			search: `?value=${item.value}&regId=${regId}&title=${title}&name=${name}&mark=${mark}`,
		});
	}
	const renderItemIcon = useMemo(() => {
		return listAll?.map((item: { title: any; img: any }, index: React.Key | undefined) => {
			const { title, img } = item;
			return (
				<div className={styles['ac-safeguard-item']} onClick={ () => setItem(item) }>
					<img className={styles['item-icon']} loading='lazy' src={img} alt="" />
					<div className={styles['item-content']}>
						<h2>{title}</h2>
					</div>
				</div>
			);
		});
	}, [listAll]);
	return (
		<section className={styles['ac-section']}>
			{ width<1200 ? <div className={classnames(styles['ac-safeguard'], 'ac-safeguard')}>
				<div className={styles['ac-header']}>
					<div className={styles['inner']}>
						<div className={styles['logo_container']}>
							<a href="/">
								<img loading="lazy" className={styles['logo_icon']} src="https://web-data.zmlearn.com/image/8UhXesmBNq64iYXEsKpb1N/logo_nav%402x.png" alt="air-class"/>
							</a>
						</div>
					</div>
				</div>
				<div className={styles['ac-safeguard-container']}>
					<h1>What school level is it for? </h1>
					<div className={styles['steps']}>
						<div className={styles['step1']}></div>
						<div className={styles['step2']}></div>
						<div className={styles['step3']}></div>
					</div>
					<div className={styles['ac-safeguard-list']}>{renderItemIcon} </div>
				</div>
			</div> :
			<div className={styles['eeo-schoolAuthReg']}>
				<div className={styles['leftBox']}>
					<div className={styles['formBox']}>
						<div className={styles['eeo-formBoxLogin']}>
							<div className={styles['ac-classes-container']}>
								<h1>Which subject do you need help?</h1>
								<div className={styles['steps']}>
									<div className={styles['step1']}></div>
									<div className={styles['step2']}></div>
								</div>
								<div className={styles['ac-safeguard-list']}>{renderItemIcon}</div>
							</div>
						</div>
					</div>
					<div className={styles['rightImg2']}></div>
					<div className={styles['header']}>
						<div className={styles['inner']}>
							<div className={styles['logo_container']}>
								<a href="/">
									<img loading="lazy" className={styles['logo_icon']} src="https://web-data.zmlearn.com/image/8UhXesmBNq64iYXEsKpb1N/logo_nav%402x.png" alt="air-class"/>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>}
		</section>
	);
}
